import type { ReactNode } from 'react';
import { cx } from '../../lib/cx';

/**
 * Horizontal gutter and maximum measure for page content.
 *
 * The gutter is deliberately generous relative to the 320px floor in spec
 * section 11: 20px each side still leaves 280px of content, which is enough for
 * a 44px-tall button with readable label.
 */
export function Container({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cx('mx-auto w-full max-w-6xl px-5 sm:px-8', className)}>{children}</div>;
}
